
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="30"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="单号">
							<c-input name="keyword" placeholder="售后单号/关联订单号"></c-input>
						</m-search-item>
						<m-search-item label="售后类型">
							<c-select name="after_sale_type" :options="afterSaleTypeOptions"></c-select>
						</m-search-item>
						<m-search-item label="老系统订单">
                            <c-select name="is_old_order" :options="oldOrderOptions"></c-select>
						</m-search-item>

						<m-search-item label="申请时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<!--列表导出（与列表同DAO同条件口径）-->
				<template #operate>
					<c-button v-if="auth('b_offline_aftersales_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_offline_aftersales_order_audit')" prepend-icon="tf-approve" color="main" @click="batchAudit(data, 2)">批量审批通过</c-button>
					<c-button v-if="auth('b_offline_aftersales_order_audit')" prepend-icon="tf-reject" color="red" :hollow="true" @click="batchAudit(data, 6)">批量驳回</c-button>
					<!--选中态 operate 槽被批量条替换，导出入口须在此复放（同客户/供应商列表先例）；勾选后仅导出选中行-->
					<c-button v-if="auth('b_offline_aftersales_order_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #after_sale_no="{data}">
					<div class="m-product-info">
						<p>售后单号：{{data.after_sale_no|| '-'}}</p>
						<p class="m-product-info-code">售后流水：{{data.after_sale_apply_no|| '-'}}</p>
					</div>
				</template>

				<template #refund_info="{data}">
					<span v-if="!Number(data.refund_amount)">-</span>
					<div v-else class="m-product-info">
						<p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
						<p class="m-product-info-code">{{data.refund_date || '-'}}</p>
					</div>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #sale_price="{data}">
					{{formatPrice(data.sale_price)}}
				</template>

				<template #after_sale_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.after_sale_amount)}}</span>
				</template>

				<template #after_sale_type="{data}">
					<c-state async dict="SALE_AFTER_SALE_TYPE" :value="data.after_sale_type"></c-state>
				</template>

				<template #after_sale_state="{data}">
					<c-state async dict="SALE_AFTER_SALE_STATE" :value="data.after_sale_state"></c-state>
				</template>

				<template #audit_user_id="{data}">
					{{data.audit_user_realname || '-'}}
				</template>

				<!--老系统订单标识（1：老系统订单，0/空：新系统订单）-->
				<template #is_old_order="{data}">
					<span v-if="data.is_old_order == 1" class="m-old-order">是</span>
					<span v-else>否</span>
				</template>

				<!--退款方式（1：原路退还；2：线下处理；空：历史数据未记录）-->
				<template #refund_type="{data}">
					<c-state v-if="data.refund_type" async dict="SALE_AFTER_SALE_REFUND_TYPE" :value="data.refund_type"></c-state>
					<span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="140"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_offline_aftersales_order_query')" icon="tf-detail" @click="viewDetail(data)">查看</c-table-button>
						<c-table-button v-if="auth('b_offline_aftersales_order_audit') && data.after_sale_state == 1"  icon="tf-approve" @click="viewDetail(data)">审核</c-table-button>
						<c-table-button v-if="auth('b_offline_aftersales_order_cancel') && data.after_sale_state == 1" icon="tf-revoke" @click="cancelAfterSale(data)">撤销</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!-- 批量审批通过弹窗（老系统订单需选退款方式，新系统订单按订单支付方式自动记录） -->
			<c-dialog ref="batchAuditDialog" title="批量审批通过" width="520">
				<div class="m-reject-box">
					<label class="m-label"><span class="m-required">*</span> 退款方式</label>
					<c-radio-group v-model="batchRefundType" :options="refundTypeOptions"></c-radio-group>
					<p class="m-ignore-tip">当前选中的均为老系统订单，所选退款方式将记录到售后单；选择【线下处理】且订单为通联支付的，仅解冻冻结资金、不记通联收支</p>
					<p v-if="batchIgnoreTip" class="m-ignore-tip">{{batchIgnoreTip}}</p>
				</div>

				<template #button>
					<c-button size="dialog" color="main" @click="submitBatchPass">确认通过</c-button>
					<c-button size="dialog" @click="$refs.batchAuditDialog.close()">取消</c-button>
				</template>
			</c-dialog>

			<!-- 批量驳回原因弹窗 -->
			<c-dialog ref="batchRejectDialog" title="批量驳回" width="480">
				<div class="m-reject-box">
					<label class="m-label"><span class="m-required">*</span> 驳回原因</label>
					<c-input v-model="batchAuditRemark" type="textarea" placeholder="请输入驳回原因" maxlength="200"></c-input>
					<p v-if="batchIgnoreTip" class="m-ignore-tip">{{batchIgnoreTip}}</p>
				</div>

				<template #button>
					<c-button size="dialog" color="red" @click="submitBatchReject">确认驳回</c-button>
					<c-button size="dialog" @click="$refs.batchRejectDialog.close()">取消</c-button>
				</template>
			</c-dialog>

			<!-- 批量审批结果弹窗（存在失败单时逐条给原因） -->
			<c-dialog ref="batchResultDialog" title="批量审批结果" width="520">
				<div class="m-batch-result">
					<p class="m-summary">审批完成：成功 <b class="m-ok">{{batchResult.success_count || 0}}</b> 单，失败 <b class="m-fail">{{batchResult.fail_count || 0}}</b> 单</p>
					<div class="m-fail-list">
						<p v-for="(item, i) in (batchResult.fail_list || [])" :key="i">{{item.after_sale_no}}：{{item.reason}}</p>
					</div>
				</div>

				<template #button>
					<c-button size="dialog" color="main" @click="$refs.batchResultDialog.close()">知道了</c-button>
				</template>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				afterSaleTypeOptions: [{
					name: '退机',
					value: 1
				}, {
					name: '补差',
					value: 2
				}],
                oldOrderOptions: [{
					name: '是',
					value: 1
				}, {
                    name: '否',
                    value: 0
                }],
				batchAuditIds: [],
				batchAuditRemark: '',
				batchIgnoreTip: '',
				batchResult: {},
				/**退款方式（1原路退还/2线下处理），与后端字典 SALE_AFTER_SALE_REFUND_TYPE 一致*/
				refundTypeOptions: [{
					name: '原路退还',
					value: 1
				}, {
					name: '线下处理',
					value: 2
				}],
				batchRefundType: 1,
				/**本批是否均为老系统订单（老订单需商家选退款方式，新订单由系统按支付方式自动判定）*/
				batchIsOldOrder: false
			}
		},

		methods: {
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********查看售后详情**********/
			viewDetail(data) {
				this.globalDialog('offlineAftersaleDetail', {
					data: {
						afterSaleId: data.after_sale_id,
						productId: data.id,
						orderType: 1
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********撤销售后**********/
			cancelAfterSale(data) {
				this.$confirm({
					message: '确认撤销售后单【' + data.after_sale_no + '】吗？撤销后不可恢复',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/aftersale/cancel_offline',
							data: {
								id: data.after_sale_id,
								cancel_reason: '手动撤销'
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '撤销成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********批量审批入口：仅待审核行可审；驳回走原因弹窗，老系统订单通过需选退款方式**********/
			batchAudit(rows, auditState) {
				var pending = (rows || []).filter(item => item.after_sale_state == 1);
				if (!pending.length) {
					this.$message({message: '请选择待审核状态的售后单', type: 'warn'});
					return;
				}
				/**按售后单ID去重：同一单多商品行被同时勾选时只审一次*/
				var ids = [];
				pending.forEach(item => {
					if (ids.indexOf(item.after_sale_id) == -1) ids.push(item.after_sale_id);
				});
				/**老系统订单与新系统订单退款方式口径不同，不允许混选批量操作*/
				var oldCount = pending.filter(item => item.is_old_order == 1).length;
				if (oldCount > 0 && oldCount < pending.length) {
					this.$message({message: '老系统订单与新系统订单不支持同时批量审核，请分开操作', type: 'warn'});
					return;
				}
				this.batchAuditIds = ids;
				this.batchIsOldOrder = oldCount > 0;
				var ignored = (rows || []).length - pending.length;
				this.batchIgnoreTip = ignored > 0 ? '另有' + ignored + '行非待审核状态，将自动跳过' : '';
				if (auditState == 6) {
					this.batchAuditRemark = '';
					this.$refs.batchRejectDialog.open();
					return;
				}
				/**老系统订单：退款方式由商家在弹窗中选择；新系统订单：按订单支付方式自动记录，直接确认*/
				if (this.batchIsOldOrder) {
					this.batchRefundType = 1;
					this.$refs.batchAuditDialog.open();
					return;
				}
				this.$confirm({
					message: '确认审批通过已选的' + ids.length + '单待审核售后单吗？新系统订单的退款方式将按订单支付方式自动记录' + (this.batchIgnoreTip ? '（' + this.batchIgnoreTip + '）' : ''),
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.submitBatchAudit(2);
					}
				});
			},

			/*********批量审批通过弹窗提交（老系统订单需选择退款方式）**********/
			submitBatchPass() {
				if (!this.batchRefundType) {
					this.$message({message: '请选择退款方式', type: 'warn'});
					return;
				}
				this.submitBatchAudit(2, null, this.batchRefundType);
			},

			/*********提交批量审批**********/
			submitBatchAudit(auditState, auditRemark, refundType) {
				var data = {
					ids: this.batchAuditIds.join(','),
					audit_state: auditState
				};
				if (auditRemark) {
					data.audit_remark = auditRemark;
				}
				/**仅老系统订单审核通过传退款方式，新系统订单由后端按订单支付方式自动判定*/
				if (auditState == 2 && refundType) {
					data.refund_type = refundType;
				}
				this.request({
					url: '/aftersale/audit_offline_batch',
					data: data,
					loading: true,
					success: (res, msg) => {
						/**驳回/老订单通过各自开过弹窗，按入口关闭避免操作未打开的弹窗*/
						if (auditState == 6) {
							this.$refs.batchRejectDialog.close();
						} else if (this.batchIsOldOrder) {
							this.$refs.batchAuditDialog.close();
						}
						this.$refs.view.update();
						var failCount = (res && res.fail_count) || 0;
						/**有失败明细单独开结果弹窗逐条给原因，toast 只留汇总*/
						if (failCount) {
							this.batchResult = res;
							this.$nextTick(() => {
								this.$refs.batchResultDialog.open();
							});
							return;
						}
						this.$message({message: msg || '批量审批完成', type: 'success'});
					}
				});
			},

			/*********批量驳回：原因必填**********/
			submitBatchReject() {
				if (!this.batchAuditRemark.trim()) {
					this.$message({message: '请输入驳回原因', type: 'warn'});
					return;
				}
				this.submitBatchAudit(6, this.batchAuditRemark.trim());
			},

			/*********加载系统业务日志列表**********/
			loadWorkLogDetail() {
				this.globalDialog('workLogDetail', {
					props: {
						workType: 30
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-reject-box {
		padding: 10px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}

		.m-ignore-tip {
			margin-top: 8px;
			font-size: 12px;
			color: #999;
		}
	}

	.m-batch-result {
		padding: 10px 15px;

		.m-summary {
			padding: 8px 10px;
			margin-bottom: 10px;
			font-size: 14px;
			background: #f5f7fa;
			border-radius: 4px;

			.m-ok {
				color: #52c41a;
			}

			.m-fail {
				color: #f5222d;
			}
		}

		.m-fail-list {
			max-height: 300px;
			overflow-y: auto;

			p {
				line-height: 22px;
				font-size: 13px;
				color: #666;
			}
		}
	}

	/*老系统订单标识*/
	.m-old-order {
		display: inline-block;
		padding: 0 6px;
		border-radius: 2px;
		font-size: 12px;
		color: #ff6900;
		background: #fff3e8;
	}

	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}
</style>
